<template>
    <ValidationObserver tag="form" ref="observer" class="row" @submit.prevent="submit">
        <div class="col-12">
            <div class="form-group">
                <label for="producto">Producto</label>
                <ValidationProvider name="producto" rules="required" v-slot="{ errors }">
                    <multiselect
                        id="producto"
                        :options="productos"
                        :class="(errors[0] ? 'is-invalid' : '')"
                        :disabled="desactivar"
                        v-model="producto.productoSeleccionado"
                        placeholder="Producto"
                        track-by="id"
                        label="name"
                    />
                    <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
                </ValidationProvider>
            </div>
            <div class="form-group">
                <label for="stock">Stock</label>
                <ValidationProvider name="stock" rules="required" v-slot="{ errors }">
                    <input type="number" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Stock" v-model="producto.stock">
                    <span v-if="errors[0]" id="exampleInputStock1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="form-group">
                <label for="precio">Precio</label>
                <ValidationProvider name="precio" rules="required" v-slot="{ errors }">
                    <input type="number" step="0.01" min="0" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Precio" v-model="producto.precio">
                    <span v-if="errors[0]" id="exampleInputPrecio1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <div class="col-12 mt-3">
            <Button id="submit-add-producto" type="submit" :disabled="disabled">Continuar</Button>
        </div>
    </ValidationObserver>
</template>

<script>
export default {
    props: ['producto', 'products', 'desactivar'],
    data() {
        return {
            productos: [],
            loading: false
        }
    },
    methods: {
        getProductos() {
            this.loading = true;

            const params = {
                filters: {
                    to_select: true
                },
                teatro_id: this.teatro.id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.teatro.productos.index'), params).then(res => {
                this.productos = res.data.data.filter(producto => {
                    return !this.products.some(p => p.id === producto.id);
                });
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            }).finally(() => {
                this.loading = false;
            });
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.producto.id = this.producto.productoSeleccionado.id;
                this.$emit('terminado');
            }
        }
    },
    computed: {
        disabled() {
            if (this.loading || !this.producto.productoSeleccionado || !this.producto.stock || !this.producto.precio) {
                return true;
            }

            return false;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    created() {
        this.getProductos();
    }
}
</script>